var DevOps = "DevOps";
var Gaming = "Игры";
var Migration = "Миграция";
var Other = "Другое";
var useCase = {
	"Use case": "Пример использования",
	"AI & machine learning": "Искусственный интеллект и машинное обучение",
	"Batch processing": "Обработка пакетов",
	"Big data, analytics, & business intelligence": "Большие данные, аналитика и бизнес-аналитика",
	"Business applications - Microsoft": "Бизнес-приложения — Microsoft",
	"Business applications - Oracle": "Бизнес-приложения — Oracle",
	"Business applications - Other": "Бизнес-приложения — Другие",
	"Business applications - SAP": "Бизнес-приложения — SAP",
	"Content delivery": "Доставка контента",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Интернет вещей",
	"Learning & certification": "Обучение и сертификация",
	"Media services": "Сервиса мультимедиа",
	Migration: Migration,
	"Mobile applications": "Мобильные приложения",
	Other: Other,
	"Storage & backup": "Хранение и резервное копирование",
	"Websites & web apps": "Веб-сайты и веб-приложения"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
